import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { PublicLayout } from '../../app/layouts/PublicLayout';
import { HelpView } from '../../components/faq/HelpView';
import { fetchPublicFaqs, fetchPublicHelp } from '../../features/faq/api/faq';
import type { Faq, HelpSettings } from '../../types';

export default function HelpPage() {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [help, setHelp] = useState<HelpSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([fetchPublicFaqs(), fetchPublicHelp()]).then(([f, h]) => { setFaqs(f); setHelp(h); }).finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout>
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] text-cyan-400 mb-2">Support</p>
        <h1 className="text-4xl sm:text-5xl tracking-tight font-light text-white">FAQ & Bantuan</h1>
      </div>
      {loading ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} /></div> : <HelpView faqs={faqs} help={help} />}
    </PublicLayout>
  );
}
